import { makeAutoObservable } from 'mobx'
import { ThemeStore } from 'theme/ThemeStore'
import GapNodes from "./nodes/GapNodes"
import { LexicalMode, LexicalRichTextEditorProps } from './LexicalRichTextEditor'
import Debouncer from 'reusable/utils/Debouncer'
import { LexicalEditor, type EditorState } from 'lexical'
import DarkEditorTheme from './themes/DarkEditorTheme'
import LightEditorTheme from './themes/LightEditorTheme'
import { LexicalComposer } from '@lexical/react/LexicalComposer'
import { getInitialLexicalContentValue } from './LexialInitalValue'
import { $generateHtmlFromNodes } from '@lexical/html'
import { notNull } from '@gap/utils/utils'

export default class LexicalRichTextEditorStore {
   sp
   debouncer = new Debouncer()
   floatingAnchorElem = null as HTMLDivElement | null

   constructor(sp: { props: LexicalRichTextEditorProps, themeStore: ThemeStore }) {
      makeAutoObservable(this)
      this.sp = sp
   }

   get editorConfig(): React.ComponentProps<typeof LexicalComposer>['initialConfig'] {
      return {
         namespace: 'Gap',
         editable: this.sp.props.disabled === true || this.sp.props.mode === LexicalMode.View ? false : true,
         editorState: getInitialLexicalContentValue(this.sp.props.value),
         theme: this.sp.themeStore.themeMode === 'dark' ? DarkEditorTheme : LightEditorTheme,
         onError(error) {
            throw error
         },
         nodes: GapNodes,
      }
   }

   onChange = (editorState: EditorState, editor: LexicalEditor) => {
      // onChange has a read and update method that can be used
      editorState.read(() => {
         this.debouncer.run(() => {
            if (this.sp.props.onChange) {
               this.sp.props.onChange(JSON.stringify(editorState))
            }
         }, 200)
      })

      if (this.sp.props.onChangeRawHtml) {
         editor.update(() => {
            const rawHtmlFromEditor = $generateHtmlFromNodes(editor, null)
            notNull(this.sp.props.onChangeRawHtml)(rawHtmlFromEditor)
         })
      }
   }

   editorRef = (_floatingAnchorElem: HTMLDivElement) => {
      if (this.floatingAnchorElem === null && _floatingAnchorElem !== null) {
         this.floatingAnchorElem = _floatingAnchorElem
      }
   }

}